
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mock-test/[id]",
      function () {
        return require("private-next-pages/mock-test/[id]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mock-test/[id]"])
      });
    }
  